import { AI_RELATED_SEARCH_SOURCE } from './gtmEventTypes/aiSearchConstants';

export const INLINE_SUGGESTION_SEARCH_SOURCE = 'inlineSuggestion';

const SEARCH_SOURCE_VALUES = [
    'autoSuggestion',
    'topSearch',
    INLINE_SUGGESTION_SEARCH_SOURCE,
    AI_RELATED_SEARCH_SOURCE,
] as const;

type SupportedSearchSource = (typeof SEARCH_SOURCE_VALUES)[number];

const isSupportedSearchSource = (searchSource: string): searchSource is SupportedSearchSource =>
    SEARCH_SOURCE_VALUES.some((supportedSource) => supportedSource === searchSource);

export const normalizeSearchSource = (searchSource?: string): SupportedSearchSource | undefined => {
    if (searchSource && isSupportedSearchSource(searchSource)) {
        return searchSource;
    }
    return undefined;
};
